import React from 'react'
import { useTranslation } from '@/shared/hooks/useIntractionTranslate'
import type { DraftJsContent } from 'pure-js/libs/Common'
import { GlintFeedbackTextSection } from './GlintFeedbackTextSection'

export interface WhatsWorkingSectionProps {
  content: string | DraftJsContent
  showGlowExperience?: boolean
  onGlowExperienceComplete?: () => void
  onGlintStateChange?: (state: 'idle' | 'running') => void
}

export const WhatsWorkingSection: React.FC<WhatsWorkingSectionProps> = (props) => {
  const { t } = useTranslation()
  return (
    <GlintFeedbackTextSection
      {...props}
      title={t('gamer.feedback.sections.whatsWorking.title', "What's working")}
      variant="positive"
    />
  )
}

export default WhatsWorkingSection
